import { getInvalidSnippetNames } from '../../components/contentPicker/selectedContent/CustomTextInput/utils/getInvalidSnippetNames';
import { useSnippetNamesContext } from '../../contexts';
import { useTranslation } from '../useTranslation';

export const useValidateSnippetReferencesInContent = () => {
  const { t } = useTranslation();
  const { snippetNames } = useSnippetNamesContext();

  return (content = '') => {
    const invalidSnippetNames = getInvalidSnippetNames(snippetNames, content);
    if (invalidSnippetNames.length) {
      return t('contentPicker.textEditor.invalidSnippetReferenceError', {
        invalidSnippetNames: invalidSnippetNames.map((name) => `"${name}"`).join(', '),
      });
    }
  };
};
